function updateData(data, reqData, updateMembers) {
    for (let i = 0; i < data.length; i++) {
        if (data[i].id === reqData.id) {
            data[i].active = reqData.active;
            data[i].name = reqData.name;
            data[i].disabledDatetime = reqData.disabledDatetime;
            if (updateMembers) {
                data[i].members = reqData.members;
            }
            break;
        }
    }
}

export const setRoleList = (state, reqResponse) => {
    const { addNewRole, data } = reqResponse || {};
    const addMembers = () => {
        const newMembers = { members: data.members };
        newMembers.members[0].nrOfGroups = data.nrOfGroups || 0;
        newMembers.members[0].nrOfUsers = data.nrOfUsers || 0;
        return newMembers;
    };
    if (addNewRole) {
        const newRole = {
            active: data.active,
            id: data.id,
            code: data.code,
            name: data.name,
            processDefinitionId: data.processDefinitionId,
            ...(data.members && data.members[0]) && addMembers(),
            ...(data.systemType) && { systemType: data.systemType },
            type: data.type
        };
        state.roleList.push(newRole);
        state.paginatedGroupsList.push(newRole);
        state.refreshData = "GROUPS";
    } else if (data && data.hasOwnProperty("editType")) {
        let updateMembers;
        let newData;
        if (!data.processDefinitionId && data.members && data.members[0]) {
            newData = { ...data, ...addMembers() };
            updateMembers = true;
        }
        updateData(state.roleList, newData || data, updateMembers);
        updateData(state.paginatedGroupsList, newData || data, updateMembers);
        state.refreshData = "GROUPS";
    } else if (Array.isArray(data)) {
        state.roleList = [...data];
    }

    state.roleTableData = state.roleList.map(role => ({
        id: role.id,
        inEdit: false,
        oldName: "",
        name: role.name
    }));

    state.loadingRoles = false;
};

export const resetGroups = (state) => {
    state.roleList = [];
};
export const setStatusRefreshData = (state, refresh) => {
    state.refreshData = refresh;
};

export const setPaginatedGroupsList = (state, response) => {
    if (response.addItems) {
        state.paginatedGroupsList = [...state.paginatedGroupsList, ...response.data];
    } else {
        state.paginatedGroupsList = [...response.data];
    }
};

export const deleteRole = (state, role) => {
    state.roleList.splice(state.roleList.indexOf(role), 1);
};

/* add permissions on role */

export const setPermissionsRoleList = (state, reqResponse) => {
    state.currentPermissions = reqResponse && reqResponse.response ? reqResponse.response : [];
};

export const setSelectedEditRoleDetails = (state, response) => {
    state.selectedEditRoleDetails = response;
};

export const setCurrentPermissionsForRole = (state, response) => {
    state.currentRolePermissions = response;
    //
    state.currentPermissions = response;
    state.permissionsDDL = state.currentPermissions.map(permission => ({
        name: permission.targetId,
        value: permission.targetId
    }));
};

/* add roles on user */
export const setRolesUserList = (state, reqResponse) => {
    state.currentRolesForUser = reqResponse && reqResponse.response ? reqResponse.response : [];
};

export const setCurrentRolesForUser = (state, response) => {
    state.currentRolesForUser = response;
    state.rolesDDL = state.currentRolesForUser.map(roles => ({
        name: roles.name,
        value: roles.id
    }));
};

export const setCurrentMembersForGroup = (state, reqResponse) => {
    state.currentMembers = reqResponse || [];
};
export const setParentsGroupSelected = (state, data) => {
    state.parentsGroupSelected = data;
};
export const setPermissionsRolesGroupSelected = (state, data) => {
    state.permissionsRolesGroupSelected = data;
};

// Manage Groups List Application

export const setGroupsAppList = (state, reqResponse) => {
    state.currentGroupsListApp = reqResponse && reqResponse.data ? reqResponse.data : [];
};

// Manage GroupsList App - set initial group list data
export const setAppGroupsInitialData = (state, resp) => {
    state.appGroupsInitialData.push({ ...resp });
};

export const setCurrentGroupSelected = (state, reqResponse) => {
    state.currentSelectedGroup = reqResponse;
};

export const updateRoleList = (state, reqResponse) => {
    const { data } = reqResponse;
    if (data.editType) {
        for (let i = 0; i < state.currentGroupsListApp.length; i++) {
            if ((data.id && state.currentGroupsListApp[i].id === data.id) || state.currentGroupsListApp[i].code === data.code) {
                state.currentGroupsListApp[i].active = data.active;
                state.currentGroupsListApp[i].name = data.name;
                state.currentGroupsListApp[i].id = data.id || "";
                state.currentGroupsListApp[i].members = data.members;
                state.currentGroupsListApp[i].nrOfGroups = data.nrOfGroups || 0;
                state.currentGroupsListApp[i].nrOfUsers = data.nrOfUsers || 0;
                state.currentGroupsListApp[i].disabledDatetime = data.disabledDatetime;
                break;
            }
        }
    } else if (reqResponse.data.id) {
        const checkIfAlreadyExist = state.currentGroupsListApp.findIndex(element => element.name === reqResponse.data.name);
        if (checkIfAlreadyExist !== -1) {
            state.currentGroupsListApp[checkIfAlreadyExist].id = reqResponse.data.id;
        }
    } else {
        state.currentGroupsListApp.push(reqResponse.data);
    }
};
export const updateRoleUsersList = (state, resp) => {
    const currentUsers = { ...state.currentSelectedGroup };
    currentUsers.users = resp;
    state.currentSelectedGroup = currentUsers;
};

// add new selected member
export const addNewSelectedMembers = (state, item) => {
    if (Array.isArray(item)) {
        item.forEach(elem => {
            if (state.selectedMembersIds.indexOf(elem.id) === -1) {
                state.selectedMembersIds.push(elem.id);
                state.selectedMembers.push(elem);
            }
        });
    } else if (state.selectedMembersIds.indexOf(item.id) === -1) {
        state.selectedMembersIds.push(item.id);
        state.selectedMembers.push(item);
    }
};

// remove selected member
export const removeSelectedMembers = (state, itemId) => {
    state.selectedMembersIds = itemId ? state.selectedMembersIds.filter(id => id !== itemId) : [];
    state.selectedMembers = itemId ? state.selectedMembers.filter(elem => elem.id !== itemId) : [];
};

// add new member
export const addNewMember = (state, item) => {
    if (item) {
        state.allMembersData = { ...state.allMembersData };
        state.allMembersData[item.id] = item.data;
    } else {
        state.allMembersData = {};
    }
};

export const appSettingsData = (state, item) => {
    if (item) {
        const checkIfAlreadyExist = state.appSettingsData.findIndex(element => {
            const editCondition = item.id ? element.id === item.id : element.name === item.name;
            return editCondition;
        });
        if (checkIfAlreadyExist !== -1) {
            state.appSettingsData[checkIfAlreadyExist] = JSON.parse(JSON.stringify(item));
        } else {
            state.appSettingsData.push(JSON.parse(JSON.stringify(item)));
        }
    } else {
        state.appSettingsData = [];
    }
};
